import { ResolveParamsConfig } from '../types'

export const resolveParameters = ({
  paramsMapping,
  sitemodelState,
  searchParams
}: ResolveParamsConfig): URLSearchParams => {
  const resolvedParams = new URLSearchParams()

  if (!paramsMapping || Object.keys(paramsMapping).length === 0) {
    return resolvedParams
  }

  Object.entries(paramsMapping).forEach(([paramName, mapping]) => {
    let paramValue: unknown = undefined

    switch (mapping.source) {
      case 'state':
        if (mapping.key && sitemodelState?.[mapping.key] !== undefined) {
          paramValue = sitemodelState[mapping.key]
        }
        break

      case 'url':
        if (mapping.key) {
          paramValue = searchParams?.get(mapping.key)
        }
        break

      case 'static':
        paramValue = mapping.value
        break

      default:
        break
    }

    if (paramValue !== undefined && paramValue !== null && paramValue !== '') {
      resolvedParams.set(paramName, String(paramValue))
    }
  })

  return resolvedParams
}

export const buildTargetUrl = ({
  baseUrl,
  paramsMapping,
  sitemodelState,
  searchParams
}: ResolveParamsConfig & { baseUrl: string }): string => {
  const resolvedParams = resolveParameters({
    paramsMapping,
    sitemodelState,
    searchParams
  })

  const url = new URL(baseUrl, window.location.origin)

  resolvedParams.forEach((value, key) => {
    url.searchParams.set(key, value)
  })

  return url.href
}
